export const getSortingQueryString = (sorting, mapper) => {
	const backendSortingColumn = mapper
		? mapper[(sorting?.column)] || sorting?.column
		: sorting?.column;

	if (!sorting || !backendSortingColumn) {
		return {};
	}

	return {
		ordering: `${
			sorting.direction === "ASC" ? "" : "-"
		}${backendSortingColumn}`
	};
};
